import React from 'react';
import { useIntl } from 'react-intl';
import { notification } from 'ui';
import WarningNotification from '../../common/publish-steps/WarningNotification';

const useConfirmationMessage = (titleKey, messageKey, cancelKey, confirmKey) => {
  const intl = useIntl();

  const showConfirm = (cb) => {
    notification.warning({
      message: intl.formatMessage({ id: titleKey || 'common.ARE_YOU_SURE' }),
      placement: 'top',
      description: <WarningNotification
        onConfirm={() => {
          cb();
          notification.destroy('confirmNotification');
        }}
        body={intl.formatMessage({ id: messageKey || 'common.ARE_YOU_SURE_CONTINUE' })}
        onClose={() => { notification.destroy('confirmNotification'); }}
        closeButtonText={intl.formatMessage({ id: cancelKey || 'common.CANCEL' })}
        confirmButtonText={intl.formatMessage({ id: confirmKey || 'common.CONFIRM' })}
      />,
      className: 'extended-notification',
      key: 'confirmNotification',
      duration: 0,
    });
  };

  return [showConfirm];
};

export default useConfirmationMessage;
